<template>
  <v-flex
     xs12
    align-self-center
    justify-center

  >
    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="totalItems"
      :no-data-text="$t('NO_DATA')"
      :no-results-text="$t('NO_DATA')"
      hide-default-footer
      :options.sync="pagination"
      :loading="loading"
      class="elevation-1"
    >

      <template v-slot:[`item.status`]="{ item }">
        {{ $t(`campaign_statuses.${getLastStatus(item.campaign_book.statuses).status}`) }}
      </template>

      <template v-slot:[`item.status_update`]="{ item }">
        {{ getLastStatus(item.campaign_book.statuses).updated_at | timeFormat }}
      </template>

      <template v-slot:[`item.actions`]="{ item }">
            <v-layout row wrap>
              <v-flex>
              </v-flex>
            </v-layout>
      </template>
    </v-data-table>
      <Paginator
        :total-items="totalItems"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.itemsPerPage"
        @change="fetchCampaigns"
      />
  </v-flex>
</template>
<script>

  import { mapActions } from 'vuex';

  import { campaignsService } from '../../../utils/services/campaigns.service';
  import Paginator from '../../shared/Paginator';

  export default {
    name: 'CampaignTeacherDetailTable',
    components: { Paginator },
    props: {
        teacherId: {
            type: Number,
            required: true,
        },
        years: {
            type: String,
            required: true,
        },
    },
    data() {
      return {
        loading: false,
        items: [],
        totalItems: 0,
        teacher: {},
        pagination: {
          page: 1,
          itemsPerPage: 60,
          sortDesc: [true],
          sortBy: ['created_at'],
        },
        headers: [
          {
            text: this.$t('fields.id'),
            align: 'left',
            value: 'campaign_book.id',
          },

          { text: this.$t('fields.isbn'), value: 'book.isbn' },
          { text: this.$t('fields.title'), value: 'book.title' },
          { text: this.$t('fields.volume'), value: 'book.volume' },
          { text: this.$t('fields.editor'), value: 'editor.name' },
          { text: this.$t('fields.status'), value: 'status' },
          { text: this.$t('fields.updated_at'), value: 'status_update' },
          { text: this.$t('fields.actions'), value: 'actions', sortable: false, align: 'center' },
        ],
        filters: {
          teacherId: this.teacherId,
          years: this.years,
        },
      };
    },
    computed: {
      requestFilters() {
        const filters = {
          teacher_id: this.filters.teacherId,
          years: this.filters.years,
        };

        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },

    },
    methods: {
      ...mapActions('alert', ['showToast']),

      async fetchCampaigns(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return campaignsService.teacherIndex({
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },

      getLastStatus(items) {
        return items[items.length - 1];
      },

    },
    async created() {
      if (this.teacherId > 0) {
        await this.fetchCampaigns(1);
      }
    },
    watch: {
      filters: {
        deep: true,
        handler() {
          this.fetchCampaigns(1);
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchCampaigns(1);
          }
        },
      },
    },
  };
</script>
